export const DECISION_ACCEPTED_CODE = 0;

export const SOCKET_METHODS_NAMES = {
  DO_CHIP: 'DoChip',
  CHIP_ADDED: 'ChipAdded',
  DECISION_TIME: 'DecisionTime',
  DECISION_TIME_ENDED: 'DecisionTimeEnded',
  ROUND_POSTPONED: 'RoundPostponed',
  CARD_RESULT: 'CardResult',
  AUTO_STAND_RESULT: 'AutoStandResult',
  INSURANCE_VALIDATION: 'InsuranceBetResultValidation',
  DOUBLE_RESULT_VALIDATION: 'DoubleResultValidation',
  SPLIT_RESULT_VALIDATION: 'SplitResultValidation',
};

export const SOCKET_DECISIONS_METHODS = [
  'SplitResult',
  'StandResult',
  'HitResult',
  'DoubleResult',
  'SurrenderResult',
  'InsuranceBetResult',
];

export const DECISION_RESULT_EVENTS = {
  HitResult: 'HitResult',
  StandResult: 'StandResult',
  SplitResult: 'SplitResult',
  DoubleResult: 'DoubleResult',
  SurrenderResult: 'SurrenderResult',
  InsuranceBetResult: 'InsuranceBetResult',
};

export const SOCKET_INVOKE_TARGETS = {
  0: 'Hit',
  1: 'Stand',
  2: 'Double',
  3: 'Split',
  4: 'Surrender',
  5: 'Insurance',
};

export const DECISION_ACTION_TYPES_FOR_STORE = {
  0: 'isHit',
  1: 'isStand',
  2: 'isSplit',
  3: 'isDouble',
  4: 'isSurrender',
  5: 'isInsurance',
  6: 'isWin',
  7: 'isLose',
  8: 'isBlackJack',
  9: 'isPush',
  10: 'isBust',
  11: 'isHandActive',
};

export const DECISION_ACTION_NAMES_FOR_STORE = {
  isHit: 0,
  isStand: 1,
  isSplit: 2,
  isDouble: 3,
  isSurrender: 4,
  isInsurance: 5,
  isWin: 6,
  isLose: 7,
  isBlackJack: 8,
  isPush: 9,
  isBust: 10,
  isHandActive: 11,
};
